import {NgxsReduxDevtoolsPluginModule} from "@ngxs/devtools-plugin";
import {AppComponent} from "./app.component";
import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {RouterModule as AppRouterModule} from "./router/router.module";
import {CoreModule} from "./core/core.module";
import {SharedModule} from "@shared/shared.module";
import {NgxsModule} from "@ngxs/store";
import { RefundStatusPopupComponent } from "./layout/refunds/refunds-grid/refunds-payment-requests-grid/refund-status-popup/refund-status-popup.component";
import { RefundCancelRefundPopupComponent } from "./layout/refunds/refunds-grid/refunds-payment-requests-grid/refund-cancel-refund-popup/refund-cancel-refund-popup.component";
import { RefundPaymentSuccesCancelPopupComponent } from "./layout/refunds/refunds-grid/refunds-payment-requests-grid/refund-payment-succes-cancel-popup/refund-payment-succes-cancel-popup.component";


@NgModule({
	declarations: [
		AppComponent,
		RefundStatusPopupComponent,
		RefundCancelRefundPopupComponent,
		RefundPaymentSuccesCancelPopupComponent,
	],
	imports: [
		AppRouterModule,
		BrowserModule,
		CoreModule,
		SharedModule,
		NgxsModule.forRoot([]),
		NgxsReduxDevtoolsPluginModule.forRoot()
	],
	providers: [],
	bootstrap: [
		AppComponent
	]
})
export class AppModule { }
